import { useEffect, useState } from "react";

import { Classes } from "@blueprintjs/core";
import { motion } from "framer-motion";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { Box, Flex } from "@/components/layout/flexbox";
import { PageContainer } from "@/components/pages_flexible/PageContainer";
import { Error403 } from "@/components/pieces/icons/svg/403";

export function PermissionErrorPage() {
  return (
    <>
      <SEOHead
        title="Access Restricted"
        description=" Sorry, but you don’t have permission to access this page. Perhaps check the URL for typos. "
      />
      <PageContainer layout="marketing">
        <PermissionError />
      </PageContainer>
    </>
  );
}

export function PermissionError() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <Flex
      justifyContent="center"
      css={{
        minHeight: "100vh",
        paddingTop: 100,
      }}
      py={6}
    >
      <div>
        <Box
          backgroundColor="#FFF"
          className={`${Classes.ELEVATION_2} round-corners`}
          p={24}
          maxWidth="100%"
          width={400}
        >
          <Flex justifyContent="center">
            {loaded ? (
              <motion.div
                animate={{
                  x: [-5, 5, -5],
                }}
                transition={{
                  duration: 0.5,
                  repeat: Infinity,
                  repeatType: "reverse",
                }}
              >
                <Error403 />
              </motion.div>
            ) : (
              <div
                css={{ width: 220, height: 220, borderRadius: "100%" }}
                className={Classes.SKELETON}
              />
            )}
          </Flex>
          <Box mt={3} className={Classes.RUNNING_TEXT}>
            <Box mb={1}>
              <b>Access Restricted</b>
            </Box>
            <Box>
              Sorry, but you don't have permission to access this page. Perhaps
              check the URL for typos.
            </Box>
          </Box>
        </Box>
      </div>
    </Flex>
  );
}
